import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { Site } from '../../dto';
import { languageStringFrag, sitePathsMilestoneGroupFrag } from './fragments';

type Variables = { renderTemplateData?: boolean };
export type SitePathsResults = { site: Site };
export const sitePathsQuery = gql`
  ${languageStringFrag}
  ${sitePathsMilestoneGroupFrag}

  query sitePaths($renderTemplateData: Boolean) {
    site {
      id
      paths(renderTemplateData: $renderTemplateData) {
        id
        name {
          ...LangStringFrag
        }
        description {
          ...LangStringFrag
        }
        reportingFrequency
        mtsView
        viewOptions
        milestoneGroups {
          ...msGroup
          subGroups {
            ...msGroup
            subGroups {
              ...msGroup
              subGroups {
                ...msGroup
                subGroups {
                  ...msGroup
                  subGroups {
                    ...msGroup
                    subGroups {
                      ...msGroup
                      subGroups {
                        ...msGroup
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export function useSitePaths(options?: QueryHookOptions<SitePathsResults, Variables>) {
  return useQuery<SitePathsResults>(sitePathsQuery, options);
}
